import {
  Card,
  Chip,
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow
} from '@material-ui/core'
import { Alert } from '@material-ui/lab'
import React from 'react'
import { TruncatedId } from '../../truncated-id'
import { Spacer } from '@vestaboard/installables'
import { useSearchByPairingCode } from '../hooks/useSearchByPairingCode'

interface ISearchPairingCode {
  pairingCode: string
}

export const SearchPairingCodeComponent = (props: ISearchPairingCode) => {
  const { data, loading, error } = useSearchByPairingCode(props.pairingCode)

  if (loading) {
    return <CircularProgress />
  }

  if (error || !data?.configurationNetwork?.device?.id) {
    return <Alert severity='warning'>No unpaired device found for pairing code "{props.pairingCode}"</Alert>
  }

  const config = data.configurationNetwork
  const device = config.device!
  const heartbeat = device.latestHeartbeat
  const connectedNetwork = heartbeat?.networks?.find(n => n.online === 'true')

  return (
    <>
      <Alert severity='info'>Found an unpaired device with pairing code "{props.pairingCode}"</Alert>
      <Spacer size='large' />
      <Card>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Device ID</TableCell>
                <TableCell>Model</TableCell>
                <TableCell>SSID</TableCell>
                <TableCell>WiFi Password</TableCell>
                <TableCell>Network Status</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell>
                  <TruncatedId value={device.id} path={`/devices/${device.id}`} />
                </TableCell>
                <TableCell>{device.model?.title || 'Unknown'}</TableCell>
                <TableCell>{config.ssid}</TableCell>
                <TableCell>{config.wpa2Key}</TableCell>
                <TableCell>
                  {connectedNetwork ? (
                    <>
                      <Chip size='small' label='Online' style={{ backgroundColor: '#4caf50', color: '#fff', marginRight: 4 }} />
                      {connectedNetwork.ssid && <span>{connectedNetwork.ssid} ({connectedNetwork.ipAddress})</span>}
                    </>
                  ) : (
                    <Chip size='small' label='Offline' />
                  )}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </Card>
    </>
  )
}
